/**
 * Appends a full-viewport loading overlay to `container`.
 * Used for initial model loads and configurator switches.
 */
export function createLoadingOverlay(container: HTMLElement): {
  show: () => void;
  hide: () => void;
} {
  const overlay = document.createElement('div');
  overlay.className = 'cfg-loading-overlay';
  overlay.setAttribute('aria-live', 'polite');
  overlay.setAttribute('aria-label', 'Loading model');
  overlay.style.display = 'none';

  overlay.innerHTML = `
    <div class="cfg-spinner" aria-hidden="true"></div>
    <span class="cfg-loading-text">Loading model…</span>
  `;

  container.appendChild(overlay);

  return {
    show: () => { overlay.style.display = 'flex'; },
    hide: () => { overlay.style.display = 'none'; },
  };
}

/**
 * Appends a small floating spinner to `container` — used during variant swaps.
 * Positioned above the model centre; fades in/out via CSS opacity transition.
 */
export function createVariantLoader(container: HTMLElement): {
  show: () => void;
  hide: () => void;
} {
  const el = document.createElement('div');
  el.className = 'cfg-variant-loader';
  el.innerHTML = `
    <div class="cfg-spinner" aria-hidden="true"></div>
    <span class="cfg-loading-text">Switching…</span>
  `;
  container.appendChild(el);

  return {
    show: () => { el.classList.add('cfg-variant-loader--visible'); },
    hide: () => { el.classList.remove('cfg-variant-loader--visible'); },
  };
}
